import { db } from "../firebase";

import {
  collection,
  addDoc,
  updateDoc,
  doc,
  getDoc,
  serverTimestamp
} from "../access/firestore";

import {
  sendWhatsAppMessage
} from "./sendWhatsApp";

import logAction
  from "../utils/logAction";
import {
  buildScheduledAt,
  getDeviceTimeZone
} from "../utils/timezone";


export async function createAppointment({

  clinicId,

  clinicData,

  paciente,

  form,

  enviarNotificacionWhatsApp = true

}) {

  if (!clinicId) {

    throw new Error(
      "No se encontró la clínica."
    );

  }

  if (!paciente?.id) {

    throw new Error(
      "No se encontró el paciente."
    );

  }


  // =========================
  // PRESUPUESTO
  // =========================

  const presupuesto =
    Number(
      form.presupuesto || 0
    );

  const timeZone =
    form.timeZone ||
    getDeviceTimeZone();

  const scheduledAt =
    buildScheduledAt(
      form.fecha,
      form.hora,
      timeZone
    );


  // =========================
  // CREAR CITA
  // =========================

  const citaRef =
    await addDoc(

      collection(
        db,
        "clinics",
        clinicId,
        "citas"
      ),

      {

        pacienteId:
          paciente.id,

        pacienteNombre:
          `${paciente.nombre || ""} ${paciente.apellidos || ""}`.trim(),

        ...form,

        timeZone,

        scheduledAt,

        presupuesto,

        pagado:
          0,

        saldo:
          presupuesto,

        estado:
          "activa",

        createdAt:
          serverTimestamp()

      }

    );


  // =========================
  // CREAR CUENTA POR COBRAR
  // =========================

  if (presupuesto > 0) {

    const cuentaRef =
      await addDoc(

        collection(

          db,

          "clinics",

          clinicId,

          "pacientes",

          paciente.id,

          "cuentasPorCobrar"

        ),

        {

          clinicId,

          tipo:
            "cita",

          citaId:
            citaRef.id,

          descripcion:

            form.motivo?.trim()
            ||
            "Consulta dental",

          total:
            presupuesto,

          pagado:
            0,

          saldo:
            presupuesto,

          estado:
            "Pendiente",

          createdAt:
            serverTimestamp()

        }

      );


    await updateDoc(

      doc(

        db,

        "clinics",

        clinicId,

        "citas",

        citaRef.id

      ),

      {

        cuentaPorCobrarId:
          cuentaRef.id

      }

    );

  }


  // =========================
  // WHATSAPP
  // =========================
  // LA CITA YA ESTÁ GUARDADA; UN FALLO DE WHATSAPP NO LA REVIERTE.
  // =========================

  let whatsappResult = null;

  if (enviarNotificacionWhatsApp) {
    try {
      const [clinicSnap, patientSnap] = await Promise.all([
        getDoc(doc(db, "clinics", clinicId)),
        getDoc(doc(db, "clinics", clinicId, "pacientes", paciente.id))
      ]);

      const currentClinicData = {
        ...(clinicData || {}),
        ...(clinicSnap.exists() ? clinicSnap.data() : {}),
        id: clinicId
      };
      const currentPatient = patientSnap.exists()
        ? { ...paciente, ...patientSnap.data(), id: patientSnap.id }
        : paciente;

      whatsappResult = await sendWhatsAppMessage(
        currentClinicData,
        currentPatient,
        "appointment_created",
        {
          fecha: form.fecha,
          hora: form.hora,
          patientId: currentPatient.id,
          patientName: `${currentPatient.nombre || ""} ${currentPatient.apellidos || ""}`.trim()
        }
      );

      if (!whatsappResult?.success) {
        console.error(
          "WhatsApp no pudo enviar la confirmación de la cita:",
          whatsappResult?.error || "El servicio no confirmó el envío."
        );
      }
    } catch (error) {
      whatsappResult = {
        success: false,
        error: error?.message || "No se pudo contactar al servicio de WhatsApp."
      };
      console.error(
        "WhatsApp no pudo enviar la confirmación de la cita:",
        error
      );
    }
  }


  // =========================
  // LOG
  // =========================
  // NO BLOQUEA LA CITA
  // =========================

  Promise.resolve()

    .then(() => {

      return logAction({

        clinicId,

        action:
          "CREAR_CITA",

        module:
          "citas",

        targetName:
          `${paciente.nombre || ""} ${paciente.apellidos || ""}`.trim(),

        extra: {

          fecha:
            form.fecha,

          hora:
            form.hora,

          motivo:
            form.motivo

        }

      });

    })

    .catch(error => {

      console.error(
        "No se pudo registrar el log de la cita:",
        error
      );

    });


  // =========================
  // DEVOLVER RESULTADO DE LA CITA Y DEL AVISO
  // =========================

  return {
    id: citaRef.id,
    whatsappResult
  };

}
